import { render } from "./LoadingVue.vue?vue&type=template&id=b47e059c&scoped=true"
import script from "./LoadingVue.vue?vue&type=script&lang=js"
export * from "./LoadingVue.vue?vue&type=script&lang=js"

import "./LoadingVue.vue?vue&type=style&index=0&id=b47e059c&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b47e059c"]])

export default __exports__